import { useEffect, useRef, useState } from "react";
import { updateSubtaskBlocker } from "../api";

type SubtaskBlockerModalProps = {
  subtask: { subtaskId?: number; name?: string; blocker?: string | null } | null;
  setSelectedBlockerSubtask: React.Dispatch<
    React.SetStateAction<SubtaskBlockerModalProps["subtask"]>
  >;
  setSubTasks: React.Dispatch<React.SetStateAction<any[]>>;
};

export default function SubtaskBlockerModal({
  subtask,
  setSelectedBlockerSubtask,
  setSubTasks,
}: SubtaskBlockerModalProps) {
  const [blockerText, setBlockerText] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const closeButtonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    setBlockerText(subtask?.blocker ?? "");
  }, [subtask?.subtaskId, subtask?.blocker]);

  const handleSave = async () => {
    if (!subtask?.subtaskId) return;
    const trimmed = blockerText.trim();
    if (!trimmed) return;

    setIsSaving(true);
    try {
      await updateSubtaskBlocker(subtask.subtaskId, trimmed);
      setSubTasks((prev) =>
        prev.map((t: any) =>
          t.subtaskId === subtask.subtaskId ? { ...t, blocker: trimmed } : t,
        ),
      );
      setSelectedBlockerSubtask(null);
      closeButtonRef.current?.click();
    } catch (error) {
      console.error("Failed to update subtask blocker:", error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div
      className="edit-modal modal fade add-wallet-modal"
      id="subtaskBlockerModal"
      tabIndex={-1}
      aria-labelledby="subtaskBlockerModalLabel"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <div>
              <h5 className="modal-title" id="subtaskBlockerModalLabel">
                Sub job blocker
              </h5>
              {subtask?.name ? (
                <p className="text-muted small mb-0 mt-1">{subtask.name}</p>
              ) : null}
            </div>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButtonRef}
              onClick={() => setSelectedBlockerSubtask(null)}
            />
          </div>
          <div className="modal-body">
            <label className="form-label" htmlFor="subtask-blocker-input">
              Blocker description
            </label>
            <textarea
              id="subtask-blocker-input"
              className="form-control"
              rows={4}
              value={blockerText}
              onChange={(e) => setBlockerText(e.target.value)}
              placeholder="Describe what is blocking this sub job…"
              disabled={isSaving}
            />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary px-3 py-2"
              data-bs-dismiss="modal"
              disabled={isSaving}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary ms-3 px-3 py-2"
              onClick={() => void handleSave()}
              disabled={isSaving || !blockerText.trim()}
            >
              {isSaving ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "Save blocker"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
